import { useTranslation } from "react-i18next";
export default function TaxHeader() {
  const { t } = useTranslation("TaxPage");

  return (
    <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
    </div>
  );
}

